import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLanguage } from "@/context/LanguageContext";
import { LanguageSelector } from "@/components/LanguageSelector";
import { AlertTriangle, Clock, LogOut, ArrowLeft } from "lucide-react";

export default function Urgency() {
  const nav = useNavigate();
  const { customer, logout } = useAuth();
  const { t } = useLanguage();

  const choose = (urgency) => nav("/quote", { state: { urgency } });

  return (
    <div className="min-h-screen bg-background">
      <LanguageSelector />
      <div className="max-w-md mx-auto px-6 py-8 min-h-screen flex flex-col">
        <button data-testid="urgency-back-btn" onClick={() => nav("/home")}
          className="flex items-center gap-2 text-primary font-medium mb-4 w-fit">
          <ArrowLeft className="h-5 w-5" /> {t("back_to_home")}
        </button>
        <div className="flex items-center justify-between pr-16">
          <div>
            <p className="text-xs uppercase tracking-widest text-muted-foreground">{t("signed_in")}</p>
            <p className="font-display text-xl font-bold text-primary">{customer?.name}</p>
          </div>
          <button data-testid="logout-btn" onClick={() => { logout(); nav("/"); }}
            className="flex items-center gap-2 text-sm text-muted-foreground hover:text-destructive transition-colors">
            <LogOut className="h-4 w-4" /> {t("logout")}
          </button>
        </div>

        <div className="flex flex-1 flex-col justify-center py-8">
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-primary text-center">
            {t("how_urgent")}
          </h2>
          <p className="text-center text-muted-foreground mt-2">{t("choose_to_start")}</p>

          <div className="mt-8 space-y-5 animate-slide-up">
            <button data-testid="urgency-urgent-btn" onClick={() => choose("Urgent")}
              className="group flex w-full flex-col items-center gap-2 rounded-3xl bg-destructive text-destructive-foreground py-10 shadow-lg hover:-translate-y-1 active:scale-95 transition-transform duration-200">
              <AlertTriangle className="h-10 w-10" />
              <span className="font-display text-2xl font-bold">{t("urgent")}</span>
              <span className="text-sm opacity-90">{t("urgent_desc")}</span>
            </button>
            <button data-testid="urgency-not-urgent-btn" onClick={() => choose("Not Urgent")}
              className="group flex w-full flex-col items-center gap-2 rounded-3xl bg-primary text-primary-foreground py-10 shadow-lg hover:-translate-y-1 active:scale-95 transition-transform duration-200">
              <Clock className="h-10 w-10" />
              <span className="font-display text-2xl font-bold">{t("not_urgent")}</span>
              <span className="text-sm opacity-90">{t("not_urgent_desc")}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
